import { AiBehaviorProfile } from 'shared/api/requests/aiBehavior/schemas'

export const getDefaultValues = (profile: AiBehaviorProfile | null) => ({
  role: profile?.role || '',
  brand_voice: profile?.brand_voice || '',
  guardrails: profile?.guardrails || '',
})
